import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import socket from '../../utils/socket';

const initialState = {
  isLoading: false,
  partners: [],
  error: null,
  partnerSelected: null
};

const slice = createSlice({
  name: 'partners',
  initialState,
  reducers: {
    // LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      console.error(state.error);
    },

    getPartners(state, action) {
      state.partners = action.payload.partners;
      state.isLoading = false;
    },

    postDemands(state) {
      state.isLoading = false;
    },

    deleteDemand(state) {
      state.isLoading = false;
    },

    postDocuments(state, action) {
      state.demand = action.payload.demand;
      state.isLoading = false;
    },

    selectedPartner(state, action) {
      state.partnerSelected = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const { selectedPartner } = slice.actions;

export function getPartners({ companyId = null, callback = null }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const result = await socket.get('/companies/partner', { companyId: companyId || null });
      dispatch(slice.actions.getPartners(result));
      if (callback) {
        callback(result.partners);
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deleteDemand(data, callback = null) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const result = await socket.delete('/demands/partner', data);
      dispatch(slice.actions.deleteDemand(result));
      callback();
    } catch (error) {
      callback(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function removeResource({ data, callback = null }) {
  return async (dispatch) => {
    try {
      const result = await socket.post('/demands/partner', data);
      callback(result);
    } catch (error) {
      callback(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function postDemands({ form, callback = null }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    const body = new FormData();

    // Construct FormData
    Object.keys(form).forEach((key) => {
      if (key === 'files' && form[key]) {
        const files = !Array.isArray(form[key]) ? Array.from(form[key]) : form[key];
        files.forEach((file) => body.append('files[]', file));
      } else if (form[key] !== null && form[key] !== undefined) {
        body.append(key, typeof form[key] === 'object' ? JSON.stringify(form[key]) : form[key]);
      }
    });

    // Headers configuration
    const headers = { Authorization: `Bearer ${socket.accessToken}` };

    try {
      const response = await axios.post(`${socket.apiUrl}/demands/partner`, body, { headers });
      dispatch(slice.actions.postDemands(response));
      if (callback) {
        callback(response.data);
      }
      return response.data; // Promise success
    } catch (err) {
      dispatch(slice.actions.hasError(err));
      if (callback) {
        callback(err);
      }
      throw err; // Promise reject
    }
  };
}
